module.exports = __webpack_public_path__ + "static/media/estimates-logo.9a1fd3fc.svg";